import { styles } from './styles';
import { INewsItemType } from '../../../../types';
import useLanguage from '../../../../utils/customHook';
import { noticeToShareHolders } from '../../../../utils/stringsConst';

type Props = {
  newsItemData: INewsItemType;
  onClick: (data: INewsItemType) => void;
};

export default function NewsItem({ newsItemData, onClick }: Props) {
  const { lang } = useLanguage();
  const isEnglish = lang.EN;

  const title = isEnglish ? newsItemData.title?.en : newsItemData.title?.fi;

  const contentToShow =
    newsItemData.action_type === noticeToShareHolders ? 2 : 4;
  const slicedContent = newsItemData.content?.slice(0, contentToShow) || [];

  return (
    <styles.NewsItemWrapper onClick={() => onClick(newsItemData)}>
      <styles.NewsItem>
        {title && (
          <styles.NewsItemActionType>{title}</styles.NewsItemActionType>
        )}
        {slicedContent.map(
          (data, index) =>
            data.value && (
              <styles.NewsItemText key={index}>
                <styles.NewsItemName>
                  {lang.EN ? data.name.en + ': ' : data.name.fi + ': '}
                </styles.NewsItemName>
                <styles.NewsItemValue>{data.value}</styles.NewsItemValue>
              </styles.NewsItemText>
            )
        )}
      </styles.NewsItem>
    </styles.NewsItemWrapper>
  );
}
